var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 9.8125C15.0625 10.875 15.1875 12.2188 15.1875 13.8438C15.1875 15.4479 15.0625 16.7917 14.8125 17.875L4.75 27.5312C3.64583 27.3646 2.66667 26.8542 1.8125 26C0.958333 25.1458 0.364583 24.1667 0.03125 23.0625L9.125 14.2812L9.75 13.8438L9.125 13.375L0.03125 4.625C0.364583 3.52083 0.958333 2.54167 1.8125 1.6875C2.66667 0.833333 3.64583 0.3125 4.75 0.125L14.8125 9.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrow);
export default __webpack_public_path__ + "static/media/white_right_arrow.aabc16bc64a52d7c3b909a1df8b9651a.svg";
export { ForwardRef as ReactComponent };